export default __webpack_public_path__ + "static/media/aud.db768a81.svg";